import {
  Edit,
  Labeled,
  SimpleForm,
  TextField,
  TextInput,
  useRecordContext,
  ListButton,
  CloneButton,
  useTranslate,
  ArrayInput,
  SimpleFormIterator,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';
import { ServerRegistration } from '../../../services/openapi/reg-service';
import { Box, Card, CardContent, FormHelperText, Grid } from '@mui/material';

const ServerRegEdit = () => {
  const translation = useTranslate();
  return (
    <Edit title={<ServerRegTitle />} component="div" mutationMode="pessimistic">
      <Box maxWidth="50em">
        <Card>
          <ListButton sx={{ marginTop: '1rem', marginLeft: '1rem' }} />
          <CloneButton sx={{ marginTop: '1rem', marginLeft: '1rem' }} />
          <SimpleForm>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Labeled source="id">
                    <TextField
                      source="id"
                      fontSize="1.4rem"
                      marginLeft=".6rem"
                    />
                  </Labeled>
                </Grid>
                <Grid item xs={12} md={6}>
                  <ReferenceInput source="ipv4" reference="available_ips">
                    <AutocompleteInput
                      optionText="id"
                      source="ipv4"
                      fullWidth
                      size="small"
                      helperText="resources.server_regs.fields.ipv4.helperText"
                      translateChoice={false}
                    />
                  </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="ipv6"
                    fullWidth
                    helperText="resources.server_regs.fields.ipv6.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <ArrayInput
                    source="macs"
                    isRequired
                    fullWidth
                    helperText="resources.server_regs.fields.macs.helperText"
                  >
                    <SimpleFormIterator fullWidth inline disableReordering>
                      <TextInput
                        source="mac"
                        helperText={false}
                        sx={{ marginRight: '.4rem', marginTop: '.4rem' }}
                      />
                      <TextInput
                        source="comment"
                        helperText={false}
                        sx={{ marginRight: '.4rem', marginTop: '.4rem' }}
                      />
                      <BooleanInput
                        source="dhcp"
                        helperText={false}
                        defaultValue={true}
                      />
                    </SimpleFormIterator>
                  </ArrayInput>
                </Grid>
                <Grid item xs={12} md={12}>
                  <BooleanInput
                    source="enabled"
                    isRequired
                    fullWidth
                    defaultValue={true}
                    helperText="resources.server_regs.fields.enabled.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="nextsrv"
                    fullWidth
                    helperText="resources.server_regs.fields.nextsrv.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextInput
                    source="pxefile"
                    fullWidth
                    helperText="resources.server_regs.fields.pxefile.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextInput
                    source="annotation"
                    multiline
                    fullWidth
                    helperText="resources.server_regs.fields.annotation.helperText"
                  />
                </Grid>
                <Grid item xs={12} md={6} display="flex" flexDirection="column">
                  <Labeled source="last_seen">
                    <TextField
                      source="last_seen"
                      fontSize="1.4rem"
                      marginLeft=".6rem"
                      emptyText="resources.server_regs.fields.last_seen.emptyText"
                    />
                  </Labeled>
                  <FormHelperText>
                    {translation(
                      'resources.server_regs.fields.last_seen.helperText',
                    )}
                  </FormHelperText>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Labeled source="warned">
                    <TextField
                      source="warned"
                      fontSize="1.4rem"
                      marginLeft=".6rem"
                    />
                  </Labeled>
                  <FormHelperText>
                    {translation(
                      'resources.server_regs.fields.warned.helperText',
                    )}
                  </FormHelperText>
                </Grid>
              </Grid>
            </CardContent>
          </SimpleForm>
        </Card>
      </Box>
    </Edit>
  );
};

const ServerRegTitle = () => {
  const record = useRecordContext<ServerRegistration>();
  const translation = useTranslate();
  return record ? (
    <span>
      {translation('resources.server_regs.edit_title')} {record.uuid}
    </span>
  ) : null;
};

export default ServerRegEdit;
